import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import tw from 'twin.macro';
import { memo } from 'react';
import Seat from './Seat';
import LeftWingSvg from '../../../../../../../assets/svgs/planeLeftWing.svg';
import RightWingSvg from '../../../../../../../assets/svgs/planeRightWing.svg';

const useStyles = makeStyles(() => ({
  wing: tw`h-full absolute top-0`,
  wingSvg: tw`absolute h-full`,
}));

const showEmptyTag = (wing, row) => {
  if (wing && (row.rowNumber < wing.firstRow || row.rowNumber > wing.lastRow)) {
    return <td>{}</td>;
  }
  return false;
};

const showWing = (wing, row, classes, isLeftWing) => {
  if (wing && wing.firstRow === row.rowNumber) {
    return (
      <td className={`relative ${isLeftWing ? 'pr-8' : 'pl-8'}`} rowSpan={wing.rowsCount}>
        <div className={`${classes.wing}`}>
          {isLeftWing ? (
            <LeftWingSvg className={`${classes.wingSvg} right-0`} />
          ) : (
            <RightWingSvg className={`${classes.wingSvg} left-0`} />
          )}
        </div>
      </td>
    );
  }
  return false;
};

const Row = ({ row, wing, flight, canPickSeat, onSeatSelect }) => {
  const classes = useStyles();

  return (
    <tr>
      {showEmptyTag(wing, row)}
      {showWing(wing, row, classes, true)}

      <td className="text-center text-xs pr-5 relative">
        {row.isExitRow && (
          <span
            className="absolute font-bold top-0 leading-none text-red-500"
            style={{ left: -30, fontSize: '3.5rem' }}
          >
            {' '}
            &lt;{' '}
          </span>
        )}
        {row.rowNumber}
      </td>
      {row.seats.map((seat, index) => (
        <Seat
          seat={seat}
          key={seat.seatNumber}
          flight={flight}
          doAddExitRowIndicator={row.isExitRow && index === row.seats.length - 1}
          canPickSeat={canPickSeat}
          onSeatSelect={onSeatSelect}
        />
      ))}
      {showEmptyTag(wing, row)}
      {showWing(wing, row, classes, false)}
    </tr>
  );
};

Row.propTypes = {
  row: PropTypes.shape({
    rowNumber: PropTypes.number,
    seats: PropTypes.arrayOf(PropTypes.shape({})),
    isExitRow: PropTypes.bool,
  }).isRequired,
  wing: PropTypes.shape({
    firstRow: PropTypes.number,
    lastRow: PropTypes.number,
    rowsCount: PropTypes.number,
  }).isRequired,
  flight: PropTypes.shape({}).isRequired,
  canPickSeat: PropTypes.bool.isRequired,
  onSeatSelect: PropTypes.func.isRequired,
};
export default memo(Row);
